module.exports = __webpack_public_path__ + "img/csv.a47e588e.svg";